import { objectOf, arrayOf, enumOf, tupleOf, anyOf } from "@altostra/type-validations";
import { number } from "@altostra/type-validations/lib/primitives";

import type { DayOfWeek, GetDecisioningStudioAgentsAppGroupIdDsaIdTimingResult } from "./types";

const isNull = (v: unknown): v is null => v === null;

const isDayOfWeek = enumOf<DayOfWeek>("sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday");

export const isGetDecisioningStudioAgentsAppGroupIdDsaIdTimingResult =
  objectOf<GetDecisioningStudioAgentsAppGroupIdDsaIdTimingResult>({
    frequencies: arrayOf(number),
    daysOfWeek: arrayOf(isDayOfWeek),
    quietHours: anyOf(isNull, tupleOf(number, number)),
    timezone: enumOf<"default" | "user">("default", "user"),
  });
